export default function Testimonial() {
  const reviews = [
    {
      name: '小林',
      role: '忠实读者',
      text: '「自从发现了韩漫网站，我的通勤时间再也不无聊了。下拉式阅读非常方便，加载速度也很快，画质清晰得让人惊艳。」',
      rating: 5,
    },
    {
      name: '阿杰',
      role: '漫画爱好者',
      text: '「这个网站的漫画分类很全，从恋爱到悬疑都有。最让我惊喜的是智能预加载功能，在地铁里也能流畅看漫。」',
      rating: 5,
    },
    {
      name: '小雨',
      role: '资深读者',
      text: '「韩漫在线观看体验真的很棒！更新速度快，界面简洁好看，每天追更已经成为我的习惯了。」',
      rating: 5,
    },
  ];

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <p className="text-xs text-foreground-500 font-medium uppercase tracking-wider">读者口碑</p>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-1">
            他们都在看
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {reviews.map((review, index) => (
            <div key={index} className="p-6 md:p-7 bg-background-100 rounded-lg">
              <div className="flex gap-1 mb-4">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center text-accent-500">
                    <i className="ri-star-fill text-sm"></i>
                  </div>
                ))}
              </div>
              <blockquote className="text-sm text-foreground-700 leading-relaxed mb-5 font-heading italic">
                {review.text}
              </blockquote>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-accent-200 flex items-center justify-center">
                  <span className="text-xs font-semibold text-accent-700">{review.name[0]}</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                  <p className="text-xs text-foreground-500">{review.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-10 flex items-center justify-center gap-8 flex-wrap">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">50万+</p>
            <p className="text-xs text-foreground-500 mt-1">每日活跃读者</p>
          </div>
          <div className="w-px h-10 bg-background-300"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-accent-500">1000+</p>
            <p className="text-xs text-foreground-500 mt-1">正版漫画作品</p>
          </div>
          <div className="w-px h-10 bg-background-300"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">99.7%</p>
            <p className="text-xs text-foreground-500 mt-1">用户满意度</p>
          </div>
        </div>
      </div>
    </section>
  );
}